import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useApi } from "../hooks/useApi";
import { type SelfRegistrationMode, api } from "../lib/api";

const MODES: SelfRegistrationMode[] = ["off", "approval", "open"];

export function SelfRegistrationToggle(): JSX.Element | null {
  const { t } = useTranslation();
  const [refresh, setRefresh] = useState(0);
  const settings = useApi(() => api.admin.settings.get(), [refresh]);
  const [busy, setBusy] = useState(false);

  if (settings.status !== "ready") return null;

  const set = async (mode: SelfRegistrationMode): Promise<void> => {
    setBusy(true);
    try {
      await api.admin.settings.setSelfRegistration(mode);
      setRefresh((r) => r + 1);
    } finally {
      setBusy(false);
    }
  };

  const current = settings.data.self_registration;
  return (
    <fieldset className="admin__field">
      <legend>{t("admin.selfReg.title")}</legend>
      {MODES.map((mode) => (
        <label key={mode} className="admin__field admin__field--inline">
          <input
            type="radio"
            name="self-registration"
            checked={current === mode}
            disabled={busy}
            onChange={() => void set(mode)}
          />
          {t(`admin.selfReg.${mode}`)}
        </label>
      ))}
      <p className="launchpad__hint">{t(`admin.selfReg.hint.${current}`)}</p>
    </fieldset>
  );
}
